export default __webpack_public_path__ + "static/solar-loan-c9728603270c78f09c4aec5e9ac2b9d4.webp";